import trackPurchase from './track-purchase'

export default {
    trackPurchase,
}
